import {
  AccountRepository as BaseAccountRepository,
  UsersRepository as BaseUsersRepository,
  PlanRepository as BasePlanRepository,
  SubscriptionRepository as BaseSubscriptionRepository,
  DeviceRepository as BaseDeviceRepository,
  GeofenceRepository as BaseGeofenceRepository,
  ChargeRepository as BaseChargeRepository,
  RulesEngineRepository as BaseRulesEngineRepository
} from "../domain/endpoints.repositories";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {MyBuddyGard} from "../domain/models";
import {ISearchReport, RepositoryConfig} from "@intellis/entityrepository";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import User = MyBuddyGard.Domain.Models.Users.User;
import PlanSearch = MyBuddyGard.Domain.Models.Plans.PlanSearch;
import PlanExtract = MyBuddyGard.Domain.Models.Plans.PlanExtract;
import AccountExtract = MyBuddyGard.Domain.Models.Account.AccountExtract;
import AccountSearch = MyBuddyGard.Domain.Models.Account.AccountSearch;
import Plan = MyBuddyGard.Domain.Models.Plans.Plan;
import Subscription = MyBuddyGard.Domain.Models.Subscriptions.Subscription;
import Device = MyBuddyGard.Domain.Models.Devices.Device;
import Geofence = MyBuddyGard.Domain.Models.Geofences.Geofence;
import ChargeSearch = MyBuddyGard.Domain.Models.Charges.ChargeSearch;
import ChargeExtract = MyBuddyGard.Domain.Models.Charges.ChargeExtract;
import Rule = MyBuddyGard.Domain.Models.Rules.Rule;
import {FileModel} from "../models/file.model";
import {FileRepository} from "./file.repository";

// Manually override non-auto-generated repository methods here to match expected behaviour
// IMPORTANT: This is not a solution but a workaround. Must be fixed
// TODO: Fix

@Injectable({providedIn: 'root'})
export class AccountRepository extends BaseAccountRepository {
  search(parameters: AccountSearch): Observable<ISearchReport<AccountExtract, AccountSearch>> {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', 'AllowCognitoIdToken');

    return super.search(parameters, { headers: headers });
  }
}

@Injectable({providedIn: 'root'})
export class UsersRepository extends BaseUsersRepository {
  get(id: string): Observable<User> {

    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', 'AllowCognitoIdToken');

    return super.get(id, { headers: headers });
  }
}

@Injectable({providedIn: 'root'})
export class PlanRepository extends BasePlanRepository {
  search(parameters: PlanSearch): Observable<ISearchReport<PlanExtract, PlanSearch>> {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', 'AllowCognitoIdToken');

    return super.search(parameters, { headers: headers });
  }

  get(id: string): Observable<Plan> {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', 'AllowCognitoIdToken');

    return super.get(id, { headers: headers });
  }

  post(model: Plan) {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', 'AllowCognitoIdToken');

    return super.post(model, { headers: headers });
  }
}

@Injectable({providedIn: 'root'})
export class SubscriptionRepository extends BaseSubscriptionRepository {
  get(id: string): Observable<Subscription> {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', '');

    return super.get(id, { headers: headers });
  }

  post(model: Subscription) {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', '');

    return super.post(model, { headers: headers });
  }
}

@Injectable({providedIn: 'root'})
export class DeviceRepository extends BaseDeviceRepository {
  get(id: string): Observable<Device> {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', '');

    return super.get(id, { headers: headers });
  }

  post(model: Device) {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', '');

    return super.post(model, { headers: headers });
  }

  delete(id: string) {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', '');

    return super.delete(id, { headers: headers });
  }
}


@Injectable({providedIn: 'root'})
export class GeofenceRepository extends BaseGeofenceRepository {
  get(id: string): Observable<Geofence> {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', '');

    return super.get(id, { headers: headers });
  }

  post(model: Geofence) {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', '');

    return super.post(model, { headers: headers });
  }

  delete(id: string) {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', '');

    return super.delete(id, { headers: headers });
  }
}

@Injectable({providedIn: 'root'})
export class ChargeRepository extends BaseChargeRepository {

  constructor(
    config: RepositoryConfig,
    http: HttpClient,
    protected file: FileRepository
  ) {
    super(config, http);
  }

  search(parameters: ChargeSearch): Observable<ISearchReport<ChargeExtract, ChargeSearch>> {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', 'AllowCognitoIdToken');

    return super.search(parameters, { headers: headers });
  }

  /* Custom */

  getDocument(number: string, contentType: string = 'application/pdf'): Observable<FileModel> {
    const params = new HttpParams();
    const url = this.config.apiBase + this.endpoint + '/number/' + number;
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', '');

    return this.file.get(url, params, headers, contentType);
  }
}

@Injectable({providedIn: 'root'})
export class RulesEngineRepository extends BaseRulesEngineRepository {
  get(id: string): Observable<Rule> {
    let headers = new HttpHeaders()
      .set('x-intellis-authorization', 'true')
      .set('x-intellis-authorization-policies', '');

    return super.get(id, { headers: headers });
  }
}
